// extracted by mini-css-extract-plugin
export default {"Content":"InternalLinksGCStyles_Content__YmY2N"};